import { authService } from "../../auth/services/auth.service";
import { UserAccess } from '../../auth/models/auth-infos'

export class PermissionService {
  hasFullAccess(entity?: string, id?: string): boolean {
    if (!authService.authInfos) {
      return false
    }
    return authService.authInfos?.userAccess !== UserAccess.Free
  }
}

export const permissionService = new PermissionService()